// Base entity interface
export interface Entity {
  x: number;
  y: number;
  width: number;
  height: number;
  active: boolean;
  
  update(deltaTime: number): void;
  render(ctx: CanvasRenderingContext2D): void;
  getBounds(): { x: number; y: number; width: number; height: number };
}

// Check collision between two entities
export function checkCollision(a: Entity, b: Entity): boolean {
  const boundsA = a.getBounds();
  const boundsB = b.getBounds();
  
  return (
    boundsA.x < boundsB.x + boundsB.width &&
    boundsA.x + boundsA.width > boundsB.x &&
    boundsA.y < boundsB.y + boundsB.height &&
    boundsA.y + boundsA.height > boundsB.y
  );
}
